<template>
  <section data-test="search-wizard-dates">
    <section
      v-if="hasDates"
      class="dates-row"
      :class="{ 'has-dates': hasDates }"
    >
      <div class="arrive">
        <span class="title">
          <img class="icon" src="@/assets/images/calendar-star.svg" />
          <translate>Arrive</translate>
        </span>
        <time :datetime="dates.arrive" class="date">
          <pu-utc-date
            tag="span"
            :date="dates.arrive"
            :options="{ weekday: 'long' }"
          />
          <pu-utc-date
            tag="em"
            :date="dates.arrive"
            :options="{ day: 'numeric', month: 'long' }"
          />
          <pu-utc-date
            tag="span"
            :date="dates.arrive"
            options="year"
            class="year"
          />
        </time>
      </div>

      <div class="arrow">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill-rule="evenodd"
          stroke-linejoin="round"
          stroke-miterlimit="2"
          clip-rule="evenodd"
          viewBox="0 0 25 21"
        >
          <path
            fill="#cccccc"
            d="M1.5 12h17.4l-6.4 6.4a1.5 1.5 0 102.1 2.1l9-8.9c.3-.3.4-.7.4-1.1 0-.4-.1-.8-.4-1.1l-9-9a1.5 1.5 0 00-2.1 2.2L18.9 9H1.5a1.5 1.5 0 100 3z"
          />
        </svg>
      </div>

      <div class="depart">
        <span class="title">
          <img class="icon" src="@/assets/images/calendar-star.svg" />
          <translate>Depart</translate>
        </span>
        <time :datetime="dates.depart" class="date">
          <pu-utc-date
            tag="span"
            :date="dates.depart"
            :options="{ weekday: 'long' }"
          />
          <pu-utc-date
            tag="em"
            :date="dates.depart"
            :options="{ day: 'numeric', month: 'long' }"
          />
          <pu-utc-date
            tag="span"
            :date="dates.depart"
            options="year"
            class="year"
          />
        </time>
      </div>
    </section>

    <div v-else>
      <translate
        v-if="required"
        tag="label"
        :class="{ error: highlightErrors }"
        class="helptext dates"
      >
        Please choose your dates...
      </translate>
      <p v-else>
        <translate tag="span" class="helptext"> Select your dates </translate>
      </p>
      <section class="dates-row unselected">
        <div class="title">
          <img class="icon" src="@/assets/images/calendar-blue.svg" />
          <translate>Arrive</translate>
        </div>
        <div class="title depart">
          <img class="icon" src="@/assets/images/calendar-blue.svg" />
          <translate>Depart</translate>
        </div>
      </section>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { ArriveDepartIso } from '../../../apps/search/types'

@Component
class DatesWizardSummary extends Vue {
  @Prop({ required: false })
  dates: ArriveDepartIso

  @Prop({ required: false, type: Boolean, default: false })
  required: boolean

  @Prop({ required: false, type: Boolean, default: false })
  highlightErrors: boolean

  get hasDates() {
    return this.dates && this.dates.arrive && this.dates.depart
  }
}

export default toNative(DatesWizardSummary)
</script>
<style scoped>
.dates-row {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.dates-row .depart {
  min-width: 40%;
}

.dates-row.unselected {
  color: var(--colour-text-light);
}

.has-dates .title {
  color: var(--colour-dark-blue);
  font-weight: 500;
}

.title {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 0 0.25em 0;
}

.dates-row.unselected .title {
  padding: 0;
}

.date {
  color: var(--colour-dark-green);
}

.date em {
  font-weight: bold;
  display: block;
  font-size: 1.1em;
}

.helptext {
  margin-bottom: 0.4em;
}

.dates {
  text-align: center;
  font-weight: bold;
  font-size: inherit;
  display: block;
  color: var(--colour-dark-blue);
}

.dates.error {
  color: var(--colour-red);
  animation: bounce 0.25s ease-in-out 0.2s forwards;
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.3);
  }
}

time {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.icon {
  height: 1em;
  margin-right: 0.35em;
  width: auto;
}

.dates-row.unselected .icon {
  filter: grayscale(1);
}

.arrow {
  align-self: center;
}

svg {
  width: 1em;
  height: auto;
}
</style>
